export const PRODUCT_CATEGORIES = [
  { value: 'PRAYER_WEAR', label: 'Prayer Wear', slug: 'prayer-wear', group: 'PRAYER_ESSENTIALS' },
  { value: 'PRAYER_ACCESSORIES', label: 'Prayer Accessories', slug: 'prayer-accessories', group: 'PRAYER_ESSENTIALS' },
  { value: 'SOUVENIRS', label: 'Souvenirs', slug: 'souvenirs', group: null },
  { value: 'OTHER', label: 'Other', slug: 'other', group: null },
] as const;

export const CATEGORY_GROUPS = [
  { value: 'PRAYER_ESSENTIALS', label: 'Prayer Essentials', slug: 'prayer-essentials' },
] as const;

export const VALID_CATEGORIES = PRODUCT_CATEGORIES.map((c) => c.value);

export const CATEGORY_SLUG_TO_VALUE: Record<string, string> = Object.fromEntries(
  PRODUCT_CATEGORIES.map((c) => [c.slug, c.value]),
);

export const CATEGORY_VALUE_TO_SLUG: Record<string, string> = Object.fromEntries(
  PRODUCT_CATEGORIES.map((c) => [c.value, c.slug]),
);

export const CATEGORY_VALUE_TO_LABEL: Record<string, string> = Object.fromEntries(
  PRODUCT_CATEGORIES.map((c) => [c.value, c.label]),
);
